import React, { useState, useRef, useEffect } from 'react';
import { Container, Paper, Typography, Grid, Box, TextField } from '@mui/material';
import { Button, Spinner } from 'react-bootstrap';
import { format, subMonths, startOfMonth, toDate } from 'date-fns';
import { getAllThatStudent } from '../../scripts/api/webAppAnalyticsApi.js';
import AllThatStudentDto from '../../DTOs/WebAppAnalytics/AllThatStudentDto';
import DateRangeDto from '../../DTOs/shared/DateRangeDto';
import DynamicTable from './shared/DynamicTable.js';
import { message } from '../shared/Message.js';

function AllThatStudent() {
  const [allThatStudentDto, setAllThatStudentDto] = useState(new AllThatStudentDto());
  const [startDate, setStartDate] = useState(format(startOfMonth(subMonths(new Date(), 3)), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [fetchStartDate, setFetchStartDate] = useState(startDate);
  const [fetchEndDate, setFetchEndDate] = useState(endDate);
  const [loading, setLoading] = useState(false);
  const endDateRef = useRef(null);

  const fetchData = async (start, end) => {
    const dateRangeDto = new DateRangeDto({
      startDate: toDate(new Date(start)).toISOString(),
      endDate: toDate(new Date(end)).toISOString(),
    });
    setLoading(true);
    try {
      let result = await getAllThatStudent(JSON.stringify(dateRangeDto));
      setAllThatStudentDto(result);
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(fetchStartDate, fetchEndDate);
  }, [fetchStartDate, fetchEndDate]);

  const handleFetchData = () => {
    setFetchStartDate(startDate);
    setFetchEndDate(endDate);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 4 }}>
        All THAT Student Information
      </Typography>

      <Box size={12} sx={{ mb: 4 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item size={4}>
            <TextField
              label="Service Date Range Start"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
          <Grid item size={4}>
            <TextField
              label="Service Date Range End"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              inputRef={endDateRef}
            />
          </Grid>
          <Grid item size={4}>
            <Button
              variant="primary"
              onClick={handleFetchData}
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : 'Update'}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {loading ? (
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Spinner animation="border" />
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item size={12}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Total Hours by Client and Service Categories
                </Typography>
                <DynamicTable data={allThatStudentDto.studentCategories} />
              </Paper>
            </Grid>

            <Grid item size={12}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Total Hours by Client and Month
                </Typography>
                <DynamicTable data={allThatStudentDto.studentHours} />
              </Paper>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
}

export default AllThatStudent;
